<tr *transloco="let t">
  <td>
    {{ portfolioActivity.dateStart | date : 'd. M. y' }}
  </td>
  <td>
    <div>{{ portfolioActivity.teacherFirstName }} {{ portfolioActivity.teacherLastName }}</div>
    <div>
      <span class="teacher-groups">{{ portfolioActivity.teacherGroups | formatTeacherGroups }}</span>
    </div>
  </td>
  <td>
    {{ portfolioActivity.title }}
  </td>
  <td>
    <div class="activity-type">{{ activityTypeData[portfolioActivity.activityType] }}</div>
  </td>
  <td class="text-end">{{ portfolioActivity.price ?? 0 | number : '1.0-0' }} {{ t('shared/czk') }}</td>
  <td>
    <div class="d-flex justify-content-end align-items-center">
      <span *ngIf="portfolioActivity.selfPayer" class="material-symbols-rounded filled text-success"> check_circle </span>
      <span *ngIf="!portfolioActivity.selfPayer" class="material-symbols-rounded filled text-primary"> cancel </span>
    </div>
  </td>
</tr>
